<script>
import appConfig from "@/app.config";
import OrdersApi from "@/services/orders-api";
import Swal from "sweetalert2";
import 'vue2-datepicker/index.css';
import CountriesApi from "@/services/countries-api";
//import ClaimApi from "@/services/claim-api";



export default {
  page: {
    title: "Bon de  Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    orderId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    showTransfer:{
      type: Boolean,
      default:null
    }
  },

  computed: {
    filteredLines() {
      if(!this.order){
        return
      }
      return this.order.lines.filter(line => line.itemVariantBarcode === null);
    }
  },
   watch: {
      'orderId': function(){
        this.getOrder();
    },

    'order.customerCountry': function() {
      this.citiesList = [];
      this.getCities();
    }
  }, 

  data() {
    return {
        
      order: {lines:[] , status:null},
      
      ORDER_STATUS_DRAFT: 0,
      ORDER_STATUS_SUBMITTED : 1,
      ORDER_STATUS_CONFIRMED : 2,

      previsionalDeliveryDate: null,
      selectedDeliveryMode:null,

      showCarrierModal: false,
      isOrderPending: false,
      changedDeliveryAddress:false,

      countriesList:[],
      citiesList: [],
   
      callHistoriesFields: [
            {key:"timeStamp",  label:"Date & heure de l'appel" , thClass:"text-left font-size-14 text-dark", tdClass:"text-left align-middle", thStyle:"width:200px;"},
            {key:"state", label:"Etat",thClass:"text-left font-size-14 text-dark",tdClass:"text-left align-middle", thStyle:"width:50px;"},
            {key:"icons", label:"",thClass:"text-left font-size-16 text-dark",tdClass:"text-left align-middle", thStyle:"width:50px;"},

            ],
            trackingPositionFields: [
            {key:"evDateStr", label:"Date Evenement",thClass:"text-left font-size-16 text-dark",tdClass:"text-left align-middle", thStyle:"width:100px;"},
            {key:"EV_INTITULE",  label:"Etat" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"width:100px;"},
 
          ],
            
            ClaimListField: [
          { key:"timestampStr", label: "Date", sortable: false, tdClass:""},
          { key:"phoneNumber", label: "Num Tel",thClass:"",tdClass:"" },
          { key:"itemTitle", label: "Produit",thClass:"",tdClass:""},
          { key:"customer", label: "Client",thClass:"",tdClass:""},
          { key:"lastModifTimestampStr", label: "Dernière Modification", sortable: false, tdClass:""},
          { key:"BL", label: "Bordereau de Livraison",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
          { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
          { key:"treat", label: "Traiter",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},

        ],
        callList: null,
        dateCall: null,
        statusCall: null ,
        callState: [{name:'Commande Confirmée', value: 0 }, {name:'Commande Annulée', value: 1}, {name:'Client injoignable', value: 2} ],

        showReasonModal: false ,
        selectedReason: null ,
        reasonCanceled: null ,
        carrierDeliveryModes:null,
        trackingPosition:{evenements:null},
        isLoadingtrackingPosition:false,
        showBlModal:false,
        returnOrderLines:null,

        isTableLoading: false,

        reason:null,
        showExhangeOrderModal:false,
        carrierExchangeDescription: null ,
        numberReceipt:null,
        codAmount:null,
        changedCustomerDeliveryPhone:false,
        customerFullAddress:null ,

 

        
    };
  },  
  
    mounted() {

    this.dateCall= new Date();

     //this.getCarrierDeliveryModes();
     this.getOrder();
     //this.getReturnOrderLines();
     this.getCountries()

   },

    methods: {

    getPointingStateLabel(pointingState) {

    switch (pointingState) {
      case 0:
        return 'Ligne En Attente';
      case 1:
        return 'Disponible';
      case 2:
        return 'Non Disponible';
      case 3:
        return 'Transfert Magasin';
      default:
        return 'Ligne En Attente';  
    }
    },

    getPointingStateColor(pointingState) {
    switch (pointingState) {
      case 0:
        return '#DC3545';  // danger (red)

      case 1:
        return '#28A745';  // success (green)
      case 2:
        return '#D3D3D3';  // light (light gray)
      case 3:
        return '#ef4b24';  // primary (yellow)
      default:
        return '#D3D3D3';  // light (light gray)
    }
    },

    cloneOrder(orderId){

      if(this.order.status == 0 && this.order.originOrder){
        this.$router.push({ path: '/modifier/commande', query: { orderId: orderId } });
      }else{
        OrdersApi.cloneOrder(orderId).then(result=>{
          if(result){
            this.$router.push({ path: '/modifier/commande', query: { orderId: result } });
          }
        })
      }
    },

    canceledEditCustomerDeliveryPhone(){
      this.customerDeliveryPhone = this.order.customerDeliveryPhone ;
      this.changedCustomerDeliveryPhone = false
    },

    deliverExchangeOrder() {
      if (this.order == null) {
        return;
      }

      const exchangeOrder = {
        reason: this.order.reason,
        orderId: this.order.id,
        carrierExchangeDescription: this.order.carrierExchangeDescription,
        numberReceipt: this.order.numberReceipt,
        codAmount: this.order.codAmount,
      };
      this.isOrderPending = true;

      OrdersApi.exchangeOrder(exchangeOrder).then(
        (order)=>{
          if(order){
            this.isOrderPending = false;
            this.order = order;
            this.customerDeliveryPhone = order.customerDeliveryPhone ;
            this.customerFullAddress = order.customerFullAddress ;
            if(order.carrierMode){
              this.selectedDeliveryMode = order.carrierMode ;
            }
            if (this.order.parcelsNumber === null) {
            this.order.parcelsNumber = 1;
          }
            if(this.order.carrierBarcode){
              this.getTrackingPosition();
            }
          }
        }

      ).finally(() => {
        this.isOrderPending = false;
        this.showExhangeOrderModal = false;
        });
    },

    downloadFiscalDocument(){
        OrdersApi.findFiscalDocumentByCode(this.order.fiscalDocumentCode)
    },



    openExhangeOrderModal(){
      this.order.carrierExchangeDescription = 'Echange de la commande N° ' + this.order.ref;
      this.showExhangeOrderModal = true

    },

     // TODO  Exchange order temporarily disabled

   /*  openExhangeModal(itemLine){
      this.showExhangeModal = true
      this.itemLine =itemLine
    }, */

    editCustomerDeliveryPhone(){
      const changecustomerDeliveryPhone ={
        orderId: this.order.id,
        customerDeliveryPhone: this.customerDeliveryPhone,
      }
      OrdersApi.changecustomerDeliveryPhone(changecustomerDeliveryPhone)
      .then(order => {
        this.order = order;
        this.changedCustomerDeliveryPhone = false

        if(order.carrierMode){
          this.selectedDeliveryMode = order.carrierMode ;
        }
        if (this.order.parcelsNumber === null) {
        this.order.parcelsNumber = 1;
      }
        if(this.order.carrierBarcode){
          this.getTrackingPosition();
        }
        this.changedDeliveryAddress=false
      })
    },

    sendNewAddress(){
      const changeDeliveryAddress ={
        orderId: this.order.id,
        // customerCountryId: this.order.customerCountry.id,
        // customerCityId: this.order.customerCity.id,
        customerFullAddress: this.customerFullAddress,
        // postalCode: this.order.postalCode,

      }
      OrdersApi.changeDeliveryAddress(changeDeliveryAddress)
      .then(order => {
        this.order = order;
        if(order.carrierMode){
          this.selectedDeliveryMode = order.carrierMode ;
        }
        if (this.order.parcelsNumber === null) {
        this.order.parcelsNumber = 1;
      }
        if(this.order.carrierBarcode){
          this.getTrackingPosition();
        }
        this.changedDeliveryAddress=false
      })

    },
    getCountries(){
      CountriesApi.getCountries().then(
          result => {
              this.countriesList = result
          })
    },
    getCities(){

        if (!this.order.customerCountry) {
            return;
        }

        CountriesApi.getCities(this.order.customerCountry.id).then(
            result => {
                this.citiesList = result
            })
    },

      downloadShipoxAwb(carrierBarcodeIndex) {
      OrdersApi.downloadFParcelAwb(this.order.id ,carrierBarcodeIndex)
      .then((awbUrl) => {
          if (awbUrl) {
            window.open(awbUrl, "_self"); 
          }
        })
    },


      statusReturnOrderToLabel(status) {
      switch(status) {
        case 0: return 'new';
        case 1: return 'inProgress';
        case 2: return 'accept';
        case 3: return 'refuse';
        case 4: return 'cancel';
        default: return '_';
      }
    },


    statusReturnOrderToColor(status) {
      switch(status) {
        case 0: return 'secondary';
        case 1: return 'info';
        case 2: return 'success';
        case 3: return  'danger'; 
        case 4: return 'danger';
        default: return 'black';
      }
    },


      // getReturnOrderLines(){
      //   OrdersApi.getReturnOrderLines(this.orderId).then(
      //     (result) => {
      //       this.returnOrderLines = result
      //     }
      //   )
      // },

      CloseBLModal(){
        this.showBlModal =false;
      },
      openBLModal(){
        this.showBlModal = true
      },

    //   getCarrierDeliveryModes() {
    //   OrdersApi.getCarrierDeliveryModes().then(
    //     (carrierDeliveryModes)=> {
    //         this.carrierDeliveryModes = carrierDeliveryModes;
    //         this.selectedDeliveryMode = this.carrierDeliveryModes[0];
    //     }
    //   )
    // },


    onStartDatetimeChanged: function(newStart) {
        var endPicker = this.$.endPicker.control;
        endPicker.minDate(newStart);
        },

    getOrder() {

      console.log("started")
      OrdersApi.getOrder(this.orderId)
      .then(order => {
        this.order = order;
        this.customerDeliveryPhone = order.customerDeliveryPhone ;
        this.customerFullAddress = order.customerFullAddress ;
        if(order.carrierMode){
          this.selectedDeliveryMode = order.carrierMode ;
        }
        if (this.order.parcelsNumber === null) {
        this.order.parcelsNumber = 1;
      }
        if(this.order.carrierBarcode){
          this.getTrackingPosition();
        }
      })
    },


    priorityToLabel(priority) {
      switch(priority) {
        case 0: return 'Basse';
        case 1: return 'Normale';
        case 2: return 'Urgente';
        default: return 'Normale';
      }
    },

    priorityToColor(priority) {
      switch(priority) {
        case 0: return 'success';
        case 1: return 'secondary';
        case 2: return 'danger';
        default: return 'sacondary';
      }
    },

    statusToLabel( order) {
      if (order == null || order.status == null) {
        return '';
      }
      switch(order.status) {
        case 0: return 'draft';
        case 1: return 'pending';
        case 2: return 'calledCustomer';
        case 3: return 'beingPrepared';
        case 4: return 'beingDelivered';
        case 5: return 'delivered';
        case 6: return 'canceled';
        default: return '_';
      }
    },
    statusToColor( order) {
      switch(order.status) {
        case 0: return 'light';
        case 1: return 'danger';
        case 2: return 'danger';
        case 3: return  'primary'; 
        case 4: return 'success';
        case 5: return 'light';
        case 6: return 'secondary';
        default: return 'secondary';
      }
    },



    callHistoriesStatusToLabel(callHistory) {
      if (callHistory == null || callHistory.state == null) {
        return '';
      }

      switch(callHistory.state) {
        case 0: return 'Commande Confirmée';
        case 1: return 'Commande Annulée';
        case 2: return 'Injoignable'
        default: return '';
      }
    },

    callHistoriesStatusToColor(callHistory) {
      switch(callHistory.state) {
        case 0: return 'success';
        case 1: return 'danger';
        case 2: return 'primary';

        default: return 'black';
      }
    },


    editConfirmedQuantity: function(line, index) {

      if (!this.order.isProcessable || this.order.status > 1) {
        return;
      }

      line.edit=true;
      let input = this.$refs['confirmedQuantityEdit-' + index][0];
      input.focus();
    },

    saveConfirmedQuantity(line) {
      
      if (line.confirmedQuantity == null) {
        line.confirmedQuantity = line.quantity
      }

      OrdersApi.saveConfirmedQuantity(line.id, line.confirmedQuantity)
        .then((order) => {
                line.edit=false;
                this.order = order;
          })
    },

    confirm() {
      Swal.fire({
        title: "Envoyer la commande pour livraison ?",
        text: "",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, envoyer !",
      })
      
      .then(result => {
        if (result.value) {
          if(this.order && this.order.parcelsNumber){
            this.isOrderPending = true
          }
          OrdersApi.confirmOrder(this.orderId, this.order.parcelsNumber, this.selectedDeliveryMode ? this.selectedDeliveryMode.id : null).then(
            (result)=>{
              if(result){
                this.order = result;
              if(this.order && this.order.carrierBarcode){
                this.isOrderPending = false

                this.getTrackingPosition();

              }

              }
             
            }
          ) .finally(() => {
        this.isOrderPending = false;
        })

        }
      });
    },


    sendSms() {
      Swal.fire({
        title: "Envoyer le numéro de ticket de caisse par SMS au numéro " + this.order.customerPhone + " ?",
        text: "",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, envoyer !",
      })
      
      .then(result => {
        if (result.value) {
          OrdersApi.sendSms(this.orderId).then(
            (response)=>{
              console.log(response)
            }
          )
        }
      });
    },


    togglePaymentMode() {

        Swal.fire({
        title: "Changer le mode de Paiement ?",
        html: "Changer le mode de paiement de la commande.",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Changer !",

      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.togglePaymentMode(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });

    },
    cancelOrder() {
      Swal.fire({
        title: "Annuler la Commande ?",
        html: "La commande sera <strong class='text-danger'>définitivement annulée</strong>",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Annuler !",

      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.cancelOrder(this.orderId, this.selectedReason)
            .then((order) => {
              if (order) {
                this.order = order;
                this.showReasonModal = false ;
              }
            })
        }
      });
    }, 

    invoicedOrder() {
      Swal.fire({
        title: "Commande prête pour la livraison et la Facturation ?",
        //html: " Cette action sera déclencher la création d’un ticket de caisse relatif à la commande dans L' <strong class='text-danger'>ERP</strong>",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, confirmer !",
      })
      .then(result => {
        if (result.value) {

          OrdersApi.invoicedOrder(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });
    },

    awbGenerate(){



      Swal.fire({
        title: "Envoyer une demande de livraison complémentaire ?",
        text: "",
        icon: "primary",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, envoyer !",
      })
      
      .then(result => {
        if (result.value) {
          
            OrdersApi.awbGenerate(this.order.id).then((order)=>{
            if(order){
              this.order = order;
            }
      })

        }
      });
    },

    downloadFParcelAwb() {
      OrdersApi.downloadFParcelAwb(this.order.id)
      .then((awbUrl) => {
          if (awbUrl) {
            window.open(awbUrl, "_self"); 
          }
        })
    },

    getTrackingPosition() {
      this.isLoadingtrackingPosition = true;
      OrdersApi.getTrackingPosition(this.orderId)
      .then((result) => {
          if (result) {
            this.trackingPosition = result ;

            this.isLoadingtrackingPosition = false

          }
        })
      .finally(() => {
          this.isLoadingtrackingPosition = false;
        });
    },

    exportEXCEL(orderId){
      OrdersApi.exportEXCEL(orderId)
    },


    
  }

}

</script>

<style>
.modal-dialog.modal-xl {
    min-width: 95% !important;
    min-height: 95% !important;
}

</style>

<template>
  <div class="m-lg-4 ">

      <div class="row mt-5 mb-4 d-print-none">
          <div class="col-6">

              <h4 class="text-primary font-size-18">COMMANDE <strong v-if="order.isExchangeOrder"  class="text-danger">D'ECHANGE</strong> N° <strong>{{order.ref}}</strong></h4>
              <h5 class="m-0"><b-badge href="#" class="font-weight-bold" :variant="statusToColor(order)">{{$t("ordersMenu.statusLabel."+statusToLabel(order))}}</b-badge></h5>
          </div>

          <div class="col-6 text-right">
            <h4 class="text-dark  text-primary font-size-14">{{order.submissionDate}}</h4>
            <h5 class="font-size-14 mt-2 font-weight-normal text-secondary"> 
              {{ order.paymentMethod === 0 ? 'Paiement Cash à la Livraison' : order.paymentMethod === 1 ? 'Paiement par carte bancaire' : '' }}
            </h5>


          </div>
      </div>


      <div :class="showBlModal ? 'd-print-none' : ''" class="row mt-4">

          <div  class ="col-12 col-lg-4 pr-lg-4">
              <div class="card h-100 ">
                  <div class="card-body card bg-Defaul p-2">
                    <!-- <h4 class="text-primary text-uppercase font-size-16">INFORMATION</h4> -->
                    
                    <div class="font-weight-bold font-size-16 text-primary">INFORMATION</div>

                    
                    <div class="text-dark font-size-14 mt-3">DATE : {{order.submissionDate}}</div>

                    <div class="text-dark font-size-14 mt-1">N° {{order.ref}}</div>

                    <div class="font-size-14 mt-4 font-weight-normal text-dark"> 
                      {{ order.paymentMethod === 0 ? 'Paiement Cash à la Livraison' : order.paymentMethod === 1 ? 'Paiement par carte bancaire' : '' }}
                    </div>

                    <div class="font-size-14 mt-2 font-weight-normal text-dark"> 
                      {{selectedDeliveryMode && selectedDeliveryMode.name ? selectedDeliveryMode.name : selectedDeliveryMode ? selectedDeliveryMode :""}}
                    </div>






                    <div v-if="order.customerReviews && order.status == 6" class="row" >
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-1 mt-4 pb-0 pl-0" style="border-top:1px solid #eff2f7;" >
                        <h4 class="card-title text-danger mb-1">Motif d'annulation de la commande</h4>
                        <p class="text-dark mb-0" >
                                {{this.order.customerReviews }} </p>
                  </div>
                </div>




                    
                    

                  </div>
              </div>
          </div>

          <div  class ="col-12 col-lg-4 pt-3 pt-lg-0 pr-lg-4 pl-lg-4">

          </div>

          <div  class ="col-12 col-lg-4 pt-3 pt-lg-0 pl-lg-4"  style="min-height:200px;">
              <div class="card h-100 ">
                  <div class="card-body card bg-Defaul p-2">
                    <div class="row" >
                      <div class="col-10 text-left">
                        <h4 class="text-primary font-weight-bold text-uppercase font-size-16">ADRESSE DE LIVRAISON</h4>
                      </div>
                    

                    </div>

                  <div  v-html="order.customerFullAddress" ></div>
                  </div>
              </div>
          </div>

      </div>
      



      
 
      <div  :class="showBlModal ? 'd-print-none' : ''"  class="row mt-4" v-if="!showCarrierModal">

        <div class="col-12 no-border-on-print ">
          <div class="card  no-border-on-print">
            <div class="card-body card bg-Defaul p-2">
              
              <div class="row" >
                <div class="col-11 text-left">
                  <h4 class="text-primary font-weight-bold text-uppercase font-size-16 mt-2">Détails de la commande</h4>
                </div>

                  <div class="col-1 mt-2 text-right">
                      <img v-if="order.paymentMethod == 0 && (order.status == 6 ||  order.status == 1 || order.status == 2 || (order.status == 0 && order.originOrder))" src="../assets/icons/edit.svg" class="mr-2 float-right" width="20px" style="cursor: pointer;" @click="cloneOrder(order.id)" >

                    <!-- <img v-if="order.status == 5" src="../assets/icons/exchange.svg" class="mr-2 float-right" width="20px" style="cursor: pointer;" @click="openExhangeOrderModal()"> -->
                  </div>
              </div>
              <div class="table-responsive mt-4">
                <table class="table" style="min-width: 1000px;">
                  <thead>
                    <tr>
                      <th style="width: 50px;" >Référence</th>
                      <!-- <th style="width: 50px;">Code à barre</th> -->
                      <th style="width: 200px;">Article</th>
                      
                      <th style="width: 100px;" class="text-right">P.U.</th>
                      <!-- <th style="width: 100px;" class="text-right">P.U. Remisé</th> -->
                      <th style="width: 100px;" class="text-right">Qté Cmdée</th>
<!--                       <th style="width: 120px; background-color: rgb(191, 234, 255,0.5);" class="text-right">Qté Confirmée</th>-->                      
                      <!-- <th style="width: 100px;" class="text-right">Remise %</th> -->
                      <th style="width: 100px;" class="text-right">Prix TTC Remisé (TND)</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                      <tr v-for="(line,i) in this.order.lines" :key="i">
                        <td class="align-middle ">
                          <!-- TODO  Exchange order temporarily disabled-->
                          <!--img  v-if="line.ref && order.status ==  5"  src="../assets/icons/exchange.svg" class="mr-2" width="16px " style="cursor: pointer;" @click="openExhangeModal(line)"/-->
                          {{ line.ref }}</td> 
                        <!-- <td class="align-middle">
                            {{line.itemVariantBarcode}}
                        </td> -->
                        <td class="align-middle">
                            <div class="font-weight-bold">{{ line.itemVariantTitle}}</div> 
                            <div v-if="line.ref"><i class="font-size-12">model : {{line.itemTitle }}</i> </div>
                            <div v-if="line.ref"><i class="font-size-12">Type : {{line.paperTypeLabel}}</i></div>
                            <a style="line-height: 30px;" class="text-info" :href="`/personnalisation-produit/${line.bagDesignCode}`">Afficher le design</a>
                              <router-link :to="{ path: `/personnalisation-produit/${line.bagDesignCode }`}" >
                                <img class="arrowup ml-1 mb-1" alt="" src="@/assets/icons/external-link.svg" width="15px" />     
                              </router-link>
                            <!-- <div v-if="line.itemVariantBarcode" class=" mediaPrint mb-2 text-uppercase font-weight-bold font-size-12"  >
                                  <span :style="`color: ${getPointingStateColor(line.pointingState)};`" class="p-0 text-uppercase" style="border-radius: 5px; font-size:10px;">{{ getPointingStateLabel(line.pointingState)}} {{   line.shopName ? (' - '+ line.shopName) : '' }}</span>
                            </div> -->
                            <!-- <div>Code à barre : {{line.itemVariantBarcode}}</div>  -->
                        </td> 

                        

                        <td class="text-right align-middle">{{ line.price }}</td>
                        <!-- <td class="text-right align-middle">{{ line.discountedPrice }}</td> -->
                        <td class="text-right align-middle">{{ line.quantity }}</td>
                       <!--  <td class="text-right text-dark font-weight-bold font-size-16;" style="background-color:rgb(191, 234, 255,0.5);">
                          
                          <div v-show="!line.edit" :class="line.quantity != line.confirmedQuantity && line.confirmedQuantity != null ? 'text-danger' : ''"  @click="editConfirmedQuantity(line, i);" >
                          {{ isCatalogList ?'':line.confirmedQuantity != null ? line.confirmedQuantity : line.quantity }}
                          <i v-if="order && order.isProcessable && order.status == ORDER_STATUS_SUBMITTED" class="fas fa-edit font-size-16 ml-2"  style="cursor:pointer" title="Modifier les quantités"></i>
                          </div>
                          
                          <div class="input-group input-group-sm pull-right mb-0" v-show="line.edit" >
                          <b-form-input v-model="line.confirmedQuantity" :ref="'confirmedQuantityEdit-' + i" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="saveConfirmedQuantity(line)" @blur="saveConfirmedQuantity(line)"></b-form-input>
                              <div class="input-group-append"  size="sm" >
                                <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="saveConfirmedQuantity(line)" ><i  class="fas fa-edit font-size-14"></i></b-button>
                              </div>
                          </div>
                        </td> -->
                        
                        <!-- <td class="text-right align-middle">{{ line.discountRate == 0 ? '' : line.totalDiscountRate + ' %' }} </td> -->

                        <!-- TODO ce calcul doit etre faut du cote serveur ou avec le bon nombre de chiffres apres la virgule -->
                        <td class="text-right align-middle">{{ line.lineTotalAmount }}</td>
                      </tr>
                
                    <tr>
                      <td colspan="4" class="border-1 text-right text-dark pt-4">
                        <strong>TOTAL REMISE</strong>
                      </td>
                      <td class="border-1 text-right pt-4">
                        <span class="m-0">{{this.order.discountAmount}}</span>
                      </td>
                    </tr>

                    <!-- <tr>
                      <td colspan="7" class="border-0 text-right">
                        <h5 class="m-0 text-dark">TOTAL HT</h5>
                      </td>
                      <td class="border-0 text-right">
                        <h5 class="m-0">{{this.order.total}} </h5>
                      </td>
                    </tr> -->

                    <!-- <tr>
                      <td colspan="8" class="border-0 text-right">
                        <strong>Taxes</strong>
                      </td>
                      <td class="border-0 text-right">
                        <span class="m-0">{{this.order.taxes}} TND</span>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="8" class="border-0 text-right">
                        <strong>T.V.A.</strong>
                      </td>
                      <td class="border-0 text-right">
                        <span class="m-0">{{this.order.vat}} TND</span>
                      </td>
                    </tr> -->

                  <tr v-if=" order.isTaxStampEnabled">
                    <td colspan="4" class="border-0 text-right">
                      <strong>TIMBRE FISCAL</strong>
                    </td>
                    <td class="border-0 text-right">
                      <span class="m-0">{{order.taxStamp}}</span>
                    </td>
                  </tr>

                    <tr>
                      <td colspan="4" class="border-0 text-right">
                        <h5 class="m-0 text-dark">TOTAL TTC</h5>
                      </td>
                      <td class="border-0 text-right">
                        <h5 class="m-0 text-dark">{{this.order.totalWithTaxes}}</h5>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            
            </div>
          </div>
        </div>

        
      </div>


        <div class="row d-print-none d-flex align-items-stretch mt-4">
          <div class ="col-12 " style="min-height:20em;" >
            <div class="card h-100 w-100">
              <div class="card-body card bg-Defaul p-2">
                <div class="row">
                    <div class="col-10">
                      <h4 class="text-primary font-weight-bold text-uppercase font-size-16">messages client</h4>
                    </div>

                    <div class="col-2 text-right">
                      <i class="fas fa-comments font-size-16 align-middle"></i> 
                    </div>
                  </div>

                <div class="mt-3">
                    <div v-if="order.message" class="alert alert-primary d-flex align-items-start">
                      <i class="fas fa-envelope-open-text me-2 mt-1"></i>
                      <div class="ml-2">
                        <strong>Message du client pour le graphiste :</strong><br>
                        <span>{{ order.message }}</span>
                      </div>
                    </div>

                    <div v-if="order.feedback" class="alert alert-info d-flex align-items-start">
                      <i class="fas fa-comment-dots me-2 mt-1"></i>
                      <div>
                        <strong class="ml-2"> Avis et Suggestions:</strong><br>
                        <span>{{ order.feedback }}</span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      

      <div class="row mt-4 d-print-none d-flex align-items-stretch">
          <!-- PAYMENTS -->
          <div :class="['col-12','pr-lg-4', order.numberReceipt ? 'col-lg-4' : 'col-lg-6', 'd-flex']" style="min-height:20em;"> 
              <div class="card h-100 w-100">
                <div class="card-body card bg-Defaul p-2">
                  <h4 class="text-primary font-weight-bold text-uppercase font-size-16">PAIEMENTS</h4>

                  <div class="m-2 m-lg-4">
                      <span class="mt-4 text-dark font-weight-bold text-uppercase">Mode de paiement</span>
                      <h5 class="font-size-14 mt-2 font-weight-normal text-dark"> 
                        {{ order.paymentMethod === 0 ? 'Paiement Cash à la Livraison' : order.paymentMethod === 1 ? 'Paiement par carte bancaire' : '' }}
                      </h5>

                      <div v-if="order.paymentAuthCode" class="mt-4 text-dark font-weight-bold text-uppercase">Détails de la Transaction</div>
                      <div class="row">
                        <div class="col-12 pl-4">
                          <div v-if="order.paymentAuthCode" class="text-uppercase mt-3">Code d'autorisation bancaire <span class="ml-2 text-dark font-weight-bold">{{ order.paymentAuthCode }}</span> </div>
                          
                          <div v-if="order.paymentTimestamp" class="text-uppercase mt-2">Date de la transaction <span class="ml-2 text-dark font-weight-bold">{{ order.paymentTimestamp }}</span> </div>

                          <div v-if="order.paymentAmount" class="text-uppercase mt-2">Montant de la transaction <span class="ml-2 text-dark font-weight-bold">{{ order.paymentAmount }}</span> </div>

                          <div v-if="order.paymentStatus" class="text-uppercase mt-2">Etat <span class="ml-2 text-dark font-weight-bold">{{ order.paymentStatus }}</span> </div>
                        </div>
                      </div>
                  </div>

                </div>
            </div>
          </div>

          <!-- GIFT CARDS -->
          <div :class="['col-12', order.numberReceipt ? 'col-lg-4 pr-lg-4': 'col-lg-6', 'mt-4', 'mt-lg-0', 'pl-lg-4', 'd-flex']" style="min-height:20em;">
              <div class="card h-100 w-100">
                  <div class="card-body card bg-Defaul p-2">
                    <h4 class="text-primary font-weight-bold text-uppercase font-size-16">Codes promo</h4>
                      
                    <div class="row m-2 m-lg-4">   
                      <div v-if="order.giftCardCode && order.giftCardAmount" class="text-dark font-weight-bold text-uppercase">Détails</div>
                      <div class="col-12">
                        <div v-if="!order.giftCardCode && !order.giftCardAmount" class="mt-2 text-secondary">Aucune code promotion n'a été utilisé pour cette commande !</div>
                      </div>
                      <div class="col-12 pl-4">

                        <div v-if="order.giftCardCode" class="text-uppercase mt-3">Code PROMO <span class="ml-2 text-dark font-weight-bold">{{ order.giftCardCode }}</span> </div>

                        <div v-if="order.giftCardAmount" class="text-uppercase mt-2">VALEUR DU CODE OU DE LA PROMO <span class="ml-2 text-dark font-weight-bold">{{ order.giftCardAmount }}</span> </div>

                        <div v-if="order.finalAmountToPay" class="text-uppercase mt-2">MONTANT RESTANT à PAYER <span class="ml-2 text-dark font-weight-bold">{{ order.finalAmountToPay }}</span> </div>
                      </div>
                    </div>

                  </div>
              </div>
          </div>
        </div>
          

</div>
</template>


<style>


    .list-inline.events {
        display: flex;
        flex-wrap: wrap; 
    }

    .list-inline-item.event-list {
        flex: 1 0 100%; 
        margin: 5px;
    }

    @media (min-width: 1200px) {
        .list-inline-item.event-list {
            max-width: calc(16.66% - 10px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .list-inline-item.event-list {
            max-width: calc(33.33% - 10px); 
        }
    }

    @media (min-width: 576px) and (max-width: 991px) {
        .list-inline-item.event-list {
            max-width: calc(33.33% - 10px); 
        }
    }

    @media (max-width: 575px) {
        .list-inline-item.event-list {
            max-width: calc(50% - 10px);
        }
    }
</style>

